import { useState } from 'react';
import CityPickerModal from './CityPickerModal';

export default function BottomSection() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <section className="bg-[#0a0a0f] py-20 px-4 md:px-8">
      <div className="max-w-4xl mx-auto text-center">
        <div
          className="rounded-3xl p-10 md:p-16 relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(168,85,247,0.12), rgba(6,182,212,0.08))',
            border: '1px solid rgba(168,85,247,0.25)',
          }}
        >
          {/* Background glow */}
          <div
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 rounded-full pointer-events-none opacity-20"
            style={{ background: 'radial-gradient(circle, #a855f7 0%, transparent 70%)', filter: 'blur(60px)' }}
          />
          <div className="relative z-10">
            <div className="text-4xl mb-6">🎁</div>
            <h2
              className="text-white font-bold text-2xl md:text-4xl mb-4 leading-tight"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              İstediğin kadar alan seçebilirsin.{' '}
              <span
                className="bg-clip-text text-transparent"
                style={{ backgroundImage: 'linear-gradient(135deg, #a855f7, #ec4899, #f59e0b)' }}
              >
                Hepsi için ayrı ayrı fırsatlar alırsın.
              </span>
            </h2>
            <p className="text-gray-400 text-base md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
              Ücretsiz, formsuz, kayıtsız. Sadece tek tıkla WhatsApp üzerinden
              dilediğin kategorilerde kampanya bildirimleri al.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button
                onClick={() => setModalOpen(true)}
                className="group relative px-8 py-4 rounded-full text-black font-bold text-lg transition-all duration-300 hover:scale-105 cursor-pointer whitespace-nowrap overflow-hidden"
                style={{
                  background: 'linear-gradient(135deg, #22c55e, #16a34a)',
                  boxShadow: '0 0 40px rgba(34,197,94,0.4)',
                }}
              >
                <span className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-xl" />
                  Şehir Seç &amp; Başla — Ücretsiz
                </span>
              </button>
              <div className="flex items-center gap-2 text-gray-500 text-sm">
                <i className="ri-shield-check-line text-green-500" />
                <span>KVKK uyumlu · Spam yok · İstediğin zaman dur</span>
              </div>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-6 mt-10">
              {[
                { icon: 'ri-user-smile-line', text: '58.000+ Kullanıcı', color: '#a855f7' },
                { icon: 'ri-percent-line', text: '%100 Ücretsiz', color: '#22d3ee' },
                { icon: 'ri-time-line', text: 'Anında Bildirim', color: '#f59e0b' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-2 text-gray-400 text-sm">
                  <i className={`${item.icon} text-base`} style={{ color: item.color }} />
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div
        className="max-w-7xl mx-auto mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-gray-600"
        style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}
      >
        <div className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b2f114d182001bcdb417b0f3094f16f5.jpeg"
            alt="Kampanya Kupon"
            className="h-6 w-auto rounded"
          />
          <span>© 2024 Kampanya Kupon. Tüm hakları saklıdır.</span>
        </div>
        <div className="flex items-center gap-4">
          <a href="#" className="hover:text-gray-400 transition-colors">Gizlilik Politikası</a>
          <a href="#" className="hover:text-gray-400 transition-colors">KVKK</a>
          <a href="#" className="hover:text-gray-400 transition-colors">İletişim</a>
        </div>
      </div>

      {modalOpen && (
        <CityPickerModal
          categoryName="Kampanya Kupon"
          section="bottom_cta"
          onClose={() => setModalOpen(false)}
        />
      )}
    </section>
  );
}
